import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { withStyles } from '@material-ui/core';
import styles from './style';
import Box from '../../../atomic/Box';
import Menu from '../../../atomic/Menu';
import CharAvatar from '../../../CharAvatar';
import Divider from '../../../atomic/Divider';
import ListItem from '../../../CardList/ListItem';
import Typography from '../../../atomic/Typography';
import getSettingItems from '../../../../structure/settings';
import useLegacyAppRedirect from '../../../../hooks/useLegacyAppRedirect';
import useDashboardLinkPrefix from '../../../../hooks/useDashboardLinkPrefix';
import { fetchPropertyOwner as apiFetchPropertyOwner } from '../../../../api/propertyowners';
import useFetchEffect from '../../../../hooks/useFetchEffect';
import {
  getPropertyOwnerFullname,
  getPropertyOwnerSubscriptionStatus,
} from '../../../../utils/properties';
import ContentLoader from '../../../loaders/ContentLoader';

const Account = ({ classes, isFromPersonal }) => {
  const history = useHistory();
  const dashboardLinkPrefix = useDashboardLinkPrefix();

  const { fetching, data: propertyOwner } = useFetchEffect({
    initialDataState: {},
    defaultDataState: {},
    initialFetchingState: true,
    apiFetchFunction: apiFetchPropertyOwner,
  });

  const { redirectToLegacyApp, redirectToPersonalDocuments } =
    useLegacyAppRedirect();

  const name = getPropertyOwnerFullname(propertyOwner);

  const isSubBoligmappaPlus = getPropertyOwnerSubscriptionStatus(propertyOwner);

  const [anchorEl, setAnchroEl] = useState(null);

  const handleClose = () => setAnchroEl(null);

  const onUsernameClick = (event) => setAnchroEl(event.currentTarget);

  const onItemClick = (passedOnClick, event) => {
    if (passedOnClick) {
      passedOnClick(event);
    }

    handleClose();
  };

  const sections = getSettingItems({
    isFromPersonal,
    history,
    dashboardLinkPrefix,
    redirectToLegacyApp,
    redirectToPersonalDocuments,
  }).filter(({ mobileOnly }) => !mobileOnly);

  return (
    <>
      <Typography
        component="div"
        fontWeight={300}
        color="textPrimary"
        onClick={onUsernameClick}
        className={classes.username}
      >
        <Box display="flex" alignItems="center">
          <Box mr={1.5} position="relative">
            {fetching ? (
              <ContentLoader height={30} width={30} variant="circle" />
            ) : (
              <>
                <CharAvatar name={name} size={30} />
                {isSubBoligmappaPlus && (
                  <div className={classes.boligmappaPlusSign} />
                )}
              </>
            )}
          </Box>
          {fetching ? (
            <ContentLoader height={20} width={150} />
          ) : (
            <span>{name}</span>
          )}
        </Box>
      </Typography>

      <Menu
        keepMounted
        MenuListProps={{
          className: classes.menu,
        }}
        anchorEl={anchorEl}
        onClose={handleClose}
        open={Boolean(anchorEl)}
      >
        {sections.map(({ id, items }, index) => (
          <div key={`account-section-item-${id}`}>
            {index !== 0 && <Divider className={classes.divider} />}
            {items.map(({ text, onClick, ...props }) => (
              <ListItem
                border={false}
                className={classes.listItem}
                textClass={classes.listItemText}
                key={`account-list-item-${text}`}
                onClick={(event) => onItemClick(onClick, event)}
                {...props}
              >
                {text}
              </ListItem>
            ))}
          </div>
        ))}
      </Menu>
    </>
  );
};

export default withStyles(styles)(Account);
